enum View {
  Start,
  Login,
  ProfiControlUser,
  Operator,
  Customer,
  CustomerCoreData,
  Issuer,
  User,
  UserCoreData,
  SalesReportOverview,
  ChargeLimitReportOverview,
  Report,
  WebChargeConfigurationOverview,
  PasswordResetOverview,
  ChangePassword,
  AdministerCards,
  GratificationSettings,
  IssuerCoreData,
  AdministerIssuerCards,
  AdministerIssuerWebcharges,
  IssuerReports,
  SepaSettings,
  CustomerBankTransfers,
  IssuerBankTransfers,
  AdminImports
}

enum Roles {
  None = 0,
  Administrator = 1,
  Hauptbenutzer = 2,
  Benutzer = 4,
  BenutzerKunde = 8,
  BenutzerGeber = 16,
  BenutzerFinanz = 32,
  BenutzerAussen = 64
}

// TODO: Rename it later to PascalCase when old role system is out of order.
enum roles {
  None = 'None',
  Administrator = 'Administrator',
  Hauptbenutzer = 'Hauptbenutzer',
  Benutzer = 'Benutzer',
  BenutzerKunde = 'BenutzerKunde',
  BenutzerGeber = 'BenutzerGeber',
  BenutzerFinanz = 'BenutzerFinanz',
  BenutzerAussen = 'BenutzerAussen'
}

enum VatType {
  Regular = 'Regular',
  Reduced = 'Reduced'
}

enum CustomerState {
  Interested = 'Interested',
  Confirmed = 'Confirmed', // Abrechnung aktiv
  Contracted = 'Contracted', // Vertrag geschlossen
  Canceled = 'Canceled' // Vertrag beendet
}

enum IssuerStatus {
  Interested = 'Interested',
  Confirmed = 'Confirmed', // Abrechnung aktiv
  Contracted = 'Contracted', // Vertrag geschlossen
  Canceled = 'Canceled' // Vertrag beendet
}

enum WebChargeInterval {
  Once = 'Once',
  Unknown = 'Unknown',
  Monthly = 'Monthly'
}

enum SepaType {
  all = 'All',
  //Sepa credit (Gutschrift) standard specification do not touch
  pain_001_003_03 = 'Credit',
  //Sepa direct debit (Lastschrift) standard specification do not touch
  pain_008_003_02 = 'Debit',
}

enum ProfiControlUserError {
  None = 'None',
  DuplicateUserName = 'DuplicateUserName',
  Unknown = 'Unknown'
}

enum TopUpRotation {
  None = 'None',
  Once = 'Once',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
  Gratification = 'Gratification',
}

enum WebChargeStatus {
  All = 'All',
  Unknown = 'Unknown',
  Success = 'Success',
  SystemError = 'SystemError',
  ConfigurationError = 'ConfigurationError',
  MaxCardLimitError = 'MaxCardLimitError',
  MaxChargeLimitError = 'MaxChargeLimitError',
  MinCardLimitError = 'MinCardLimitError',
  WebchargeDisabled = 'WebchargeDisabled'
}

enum ResponseState {
  unknown = 'Unknown',
  success = 'Success',
  error = 'Error'
}

enum TransactionType {
  all = 'All',
  terminal = 'Terminal',
  other = 'Other',
  charges = 'Charges',
}

enum CardStates {
  Unknown = 'All',
  Unassigned = 'Unassigned',
  Assigned = 'Assigned'
}

enum ErrorCodes {
  unknown = 'ERR_UNKNOWN',
  duplicate_username = 'ERR_DUPLICATE_USERNAME',
  not_found = 'ERR_MISSING_RECORD',
  err_reset_not_possible = 'ERR_RESET_NOT_POSSIBLE',
}

enum AccountingPeriod {
  daily = 'Daily',
  weekly = 'Weekly',
  biweekly = 'Biweekly',
  monthly = 'Monthly'
}

enum PaymentMethod {
  invoice = 'Invoice',
  baseDebit = 'BasicDebit',
  companyDebit = 'CompanyDebit'
}

enum DebitType {
  all = 'All',
  basic = 'Basic',
  company = 'Company'
}

enum PersonalizationType {
  Text = 'Text',
  LogoPart = 'LogoPart',
  LogoFull = 'LogoFull'
}


export {
  ResponseState,
  WebChargeStatus,
  TopUpRotation,
  ProfiControlUserError,
  SepaType,
  WebChargeInterval,
  IssuerStatus,
  VatType,
  CustomerState,
  Roles,
  View,
  TransactionType,
  CardStates,
  ErrorCodes,
  AccountingPeriod,
  PaymentMethod,
  DebitType,
  PersonalizationType,
  roles
}
